import React, { useEffect, useState } from "react";
import styles from "./MainData.module.scss";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../PrivateRoute/PrivateRoute";
import { profileChangeData } from "../../../api/userApi";
import { useQueryClient } from "@tanstack/react-query";
import { useNotification } from "../../../contexts/NotificationToast";
import CustomInput from "../../CustomInput/CustomInput";
import CustomButton from "../../CustomButton/CustomButton";

const MainData = () => {
  const { t } = useTranslation();
  const { userData, isLoading } = useAuth();
  const queryClient = useQueryClient();
  const { showNotification } = useNotification();

  useEffect(() => {
    if (!isLoading) {
      setEmail(userData?.current_email);
      setFirstName(userData?.first_name);
      setLastName(userData?.last_name);
      setBirthDate(userData?.date_of_birth);
      setSelectedGender(userData?.gender);
    }
  }, [isLoading, userData]);
  const [email, setEmail] = useState();
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [birthDate, setBirthDate] = useState("17.07.1997");
  const [selectedGender, setSelectedGender] = useState(t("genderOptions.male"));

  const options = [
    t("genderOptions.male"),
    t("genderOptions.female"),
    t("genderOptions.other"),
  ];

  const handleSave = async () => {
    const updatedData = {
      current_email: email,
      first_name: firstName,
      last_name: lastName,
      date_of_birth: birthDate,
      gender: selectedGender,
    };

    try {
      await profileChangeData(updatedData);
      showNotification("Successfully changed", 200);
      queryClient.invalidateQueries(["authProfile"]);
    } catch (error) {
      showNotification("Error", 400);
      console.log(error);
    }
  };

  return (
    <div className={styles.mainDataContainer}>
      <h2 className={styles.title}>{t("mainInfo")}</h2>

      <CustomInput label="Email" value={email} />

      <CustomInput
        label={t("userData.firstName")}
        value={firstName}
        onChange={(e) => setFirstName(e.target.value)}
      />

      <CustomInput
        label={t("userData.lastName")}
        value={lastName}
        onChange={(e) => setLastName(e.target.value)}
      />

      <CustomInput
        label={t("userData.birthDate")}
        value={birthDate}
        onChange={(e) => setBirthDate(e.target.value)}
        type="date"
      />

      <div className={styles.gender}>
        {t("gender")}
        <div className={styles.switchContainer}>
          {options.map((option) => (
            <button
              key={option}
              className={`${styles.switchButton} ${
                selectedGender === option ? styles.active : ""
              }`}
              onClick={() => setSelectedGender(option)}
            >
              {option}
            </button>
          ))}
        </div>
      </div>

      <CustomButton
        blue
        width="300px"
        className={styles.saveButton}
        onClick={handleSave}
      >
        {t("saveButton")}
      </CustomButton>
    </div>
  );
};

export default MainData;
